
<!-- <ng-container *ngIf="screenWidth > 768"> -->
  <app-quote-step9-desktop [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep($event)" (onPrevStep)= "prevStep($event)"></app-quote-step9-desktop>
<!-- </ng-container> -->

<!-- <ng-container *ngIf="screenWidth <= 768">
  <app-quote-step9-mobile [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep($event)" (onPrevStep)= "prevStep($event)"></app-quote-step9-mobile>
</ng-container> -->